<section class="content-page px-0 px-lg-4 px-xxl-5">
  <div class="banner2">
    <div class="d-flex flex-column-reverse flex-lg-row align-items-start gap-3 gap-md-5">
      <div class="left px-4 px-lg-0 d-flex flex-column gap-3 gap-md-4 ">
        <h2 class="title fw-bold fs-sm-4 fs-xxl-2 mb-0">
          Diseñamos estructuras que perduran y estrategias que generan libertad
        </h2>
        <div class="d-flex align-items-center fs-6">
          <img src="/assets/images/bank.webp" alt="institution" class="icono me-2 mb-auto">
          <span class="text-blue">Alianzas con instituciones de alto marco regulatorio</span>
        </div>
        <div class="d-flex align-items-center fs-6">
          <img src="/assets/images/global.webp" alt="global" class="icono me-2 mb-auto">
          <span class="text-blue">Acceso a los mercados que lideran la economía global</span>
        </div>
        <p class="texto fw-light fs-6 mb-0">
          En Kaizen Wealth Planning creemos que la verdadera riqueza se construye con integridad y propósito,
          es por eso que evaluamos cada decisión como si fuera propia. Te acompañaremos en todas las etapas
          del camino a través de banca privada, estrategias de aporte periódico, cobertura financiera internacional
          y estructuración legal.
        </p>
        <p class="texto fw-light fs-6 mb-0">
          Nuestra esencia es la excelencia y la seguridad patrimonial. Aplicamos un due diligence más riguroso que el
          estándar de la región y brindamos acceso a instituciones financieras de clase mundial, acompañados por
          asesores independientes, formados y equipados con tecnología de vanguardia.
        </p>
      </div>
      <div class="text-center p-0 z-2 content-image-banner">
        <img src="/assets/images/banner1.webp" alt="team" class="img-fluid team-img">
      </div>
    </div>
  </div>
</section>
